// Offroad Prints site-wide tweaks.

// Upload-Lift writes its own "required fields" message; replace it with our wording.
(() => {
  const FROM = /please fill in all required input fields/i;
  const TO = 'Please fill in all required customization fields';

  const fix = (root) => {
    root.querySelectorAll?.('.cl-upload--error p').forEach((p) => {
      if (FROM.test(p.textContent)) p.textContent = TO;
    });
  };

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.target.closest?.('.cl-upload--wrapper') || m.target.querySelector?.('.cl-upload--wrapper')) {
        fix(document);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  fix(document);
})();
